var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiddenGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 120,
    viewBox: "0 0 118 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3666_112007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.73 69.6349C96.73 79.7449 92.64 88.8849 86.01 95.5149C79.39 102.135 70.24 106.235 60.13 106.235C50.02 106.235 40.88 102.145 34.25 95.5149C27.63 88.8949 23.54 79.7449 23.54 69.6349C23.54 59.5249 27.63 50.3849 34.26 43.7549C40.88 37.1449 50.03 33.0449 60.13 33.0449C70.24 33.0449 79.38 37.1349 86.01 43.7649C92.63 50.3849 96.73 59.5349 96.73 69.6349Z",
    fill: "url(#paint0_radial_3666_112007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0407 79.4259C67.6972 87.2076 54.0382 88.661 46.3126 88.3558C45.7353 88.333 45.252 88.79 45.252 89.3678V89.6016C45.252 90.0591 45.5614 90.4604 46.0087 90.5558C48.9173 91.1764 52.6136 91.3283 57.23 90.9993C61.0085 90.73 65.3862 89.5999 68.5037 88.3008C72.8009 86.5102 73.1737 81.9945 72.4638 79.3078C72.2535 78.512 71.3657 78.6697 71.0407 79.4259Z",
    fill: "#9B5AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4325 44.8865L83.8875 38.8099L85.1025 26.4055C73.16 19.5105 59.557 18.1115 47.2218 21.4168L43.9239 33.8888L52.7451 42.0301C59.8074 40.1377 67.5909 40.9365 74.4325 44.8865Z",
    fill: "#736ACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37 94.6059C110.265 82.6634 111.663 69.0604 108.358 56.7252L95.7625 52.8016L87.7449 62.2485C89.6373 69.3108 88.8335 77.1029 84.8885 83.9359L90.2201 94.6813L103.37 94.6059Z",
    fill: "#5BD6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0575 117.867L77.2435 107.617L67.5342 97.2538C60.4719 99.1462 52.6798 98.3425 45.8468 94.3975L35.7314 100.878L35.1768 112.878C47.1107 119.768 60.7137 121.167 73.0575 117.867Z",
    fill: "#FBC072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1866 86.0034L32.5297 77.0447C30.6374 69.9823 31.4411 62.1902 35.3861 55.3573L30.6027 45.1824L16.9051 44.6873C10.0101 56.6298 8.61119 70.2328 11.9164 82.568L25.1866 86.0034Z",
    fill: "#FF71A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3777 55.3515L16.8968 44.6815C23.7918 32.739 34.8728 24.726 47.208 21.4208L52.7314 42.0341C45.669 43.9265 39.3277 48.5099 35.3777 55.3515Z",
    fill: "#918BD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1772 112.879C23.2347 105.984 15.2217 94.9029 11.9165 82.5677L32.5212 77.0394C34.4135 84.1018 39.0056 90.448 45.8386 94.393L35.1686 112.874L35.1772 112.879Z",
    fill: "#FF97C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0578 117.867L67.5345 97.2538C74.5969 95.3615 80.9432 90.7694 84.8882 83.9364L103.369 94.6064C96.4791 106.54 85.3981 114.553 73.0578 117.867Z",
    fill: "#F9F097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7495 62.2403C85.8572 55.1779 81.2651 48.8316 74.4322 44.8866L85.1022 26.4057C97.0447 33.3007 105.058 44.3817 108.363 56.717L87.7495 62.2403Z",
    fill: "#A4E6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3666_112007",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5675 72.0734) scale(31.1299 31.1299)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2738,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5359,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8051,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3666_112007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117.94,
    height: 119.13,
    fill: "white",
    transform: "translate(0.0302734 0.43457)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenGallery);
export default __webpack_public_path__ + "static/media/hidden-gallery.b4bf306bd7ed324c080eb214c682b6bc.svg";
export { ForwardRef as ReactComponent };